// IMPORTANT: This import and patch must remain at the very top of main.ts.
// It ensures that all dynamically created <style> tags receive the CSP nonce
// before any Angular or third-party code (e.g., @angular/flex-layout) runs.
// Do not move below other imports, or libraries like Flex Layout may not get the correct nonce.
import { patchNonceForDynamicStyles } from './app/shared/utils/csp-nonce-patch';
patchNonceForDynamicStyles();

import { enableProdMode, importProvidersFrom, provideZoneChangeDetection }  from '@angular/core';
import { ReactiveFormsModule }                  from '@angular/forms';
import { MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS } from '@angular/material/progress-spinner';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS }       from '@angular/material/form-field';
import { provideAnimations }                    from '@angular/platform-browser/animations';
import { BrowserModule, bootstrapApplication }  from '@angular/platform-browser';

import { from }               from 'rxjs';
import { environment }        from './environments/environment';
import { AppRoutingModule }   from './app/app-routing.module';
import { AwsCognitoModule }   from './app/core/aws-cognito/aws-cognito.module';
import { CoreModule }         from './app/core/core.module';
import { DocumentsModule }    from './app/pages/secured/documents/documents.module';
import { ManageAccessModule } from './app/pages/secured/manage-access/manage-access.module';
import { PublicModule }       from './app/pages/public/public.module';
import { SharedModule }       from './app/shared/shared.module';
import { AppComponent }       from './app/app.component';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideZoneChangeDetection(),
    importProvidersFrom(
      AppRoutingModule,
      AwsCognitoModule,
      BrowserModule,
      CoreModule,
      DocumentsModule,
      ManageAccessModule,
      PublicModule,
      ReactiveFormsModule,
      SharedModule
    ),
    provideAnimations(),
    {
      provide: MAT_PROGRESS_SPINNER_DEFAULT_OPTIONS,
      useValue: { _forceAnimations: true },
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { hideRequiredMarker: true },
    },
  ],
}).catch((error) => logClientError(error));

function logClientError(error: unknown) {
  from(
    fetch(environment.apiBaseUrl + environment.api.endpoints.sessionMetadata)
      .then(response => {
        return response !== null;
      })
  ).subscribe({
    next: response => {
      if (!response) {
        return;
      }

      const requestHeaders = {
        'Content-Type': 'application/json',
        'Cache-Control': 'no-cache, no-store, max-age=0, must-revalidate',
        'Pragma': 'no-cache'
      };

      const data = {
        method: 'POST',
        body: JSON.stringify(error, Object.getOwnPropertyNames(error)),
        headers: requestHeaders,
        referrer: 'no-referrer'
      };

      fetch(environment.apiBaseUrl + environment.api.endpoints.clientLogs.error, data)
        .then()
        .catch(error => console.error(error));
    },
    error: error => console.error(error)
  });
}
